import React from 'react';
import { inject, observer } from 'mobx-react';
import WrappedPrescriptionHistoryTable from '../../HcpPatientDashboard/Table/PrescriptionHistory.tsx';
import DocumentsTable from '../../HcpPatientDashboard/Table/DocumentsTable.tsx';
import { Stack } from '@mantine/core';
import LifeEventsTable from '../../HcpPatientDashboard/Table/LifeEventsTable.tsx';

export type IPatientMedicalInformationProps = object;

const PatientMedicalInformation: React.FC<IPatientMedicalInformationProps> = inject()(
    observer(() => {
        return (
            <Stack w={'100%'}>
                <WrappedPrescriptionHistoryTable />
                <DocumentsTable />
                <LifeEventsTable />
            </Stack>
        );
    }),
);

export default PatientMedicalInformation;
